import React, { useState } from "react";
import { useForm } from "react-hook-form";
import ForgotPasswordModal from "./ForgotPassword"; // Modal component
import ResetPasswordModal from "./ResetPassword"; // Modal component
import { STATUS_CODES } from "../utils/statusCode";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../contexts/LoaderContext";
import { useDispatch } from "react-redux";
import { setUserData, userLogin } from "../store/slices/userSlice";

const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange" }); // live validation on every change

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] =
    useState(false);
  const [getEmail, setEmail] = useState("");
  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const dispatch = useDispatch();

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const closeResetPasswordModal = () => {
    setIsResetPasswordModalOpen(false);
  };

  const onSubmit = async (formdata) => {
    setLoading(true);
    const postData = new FormData();
    postData.append("email", formdata.email);
    postData.append("password", formdata.password);

    dispatch(userLogin(postData)).then((response) => {
      const responsejson = response.payload;
      if (responsejson?.code === STATUS_CODES.SUCCESS) {
        navigate("/dashboard");
        dispatch(setUserData(responsejson?.data));
        localStorage.setItem("userToken", responsejson.data.token);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  return (
    <>
      <div className="flex h-full items-center justify-center md:-mt-2 sm:mt-10">
        <div className="w-full max-w-sm p-6 border border-gray-300 rounded-md shadow-md">
          <div className="flex items-center justify-center mb-6">
            <img src="logo.png" alt="Logo" className="w-20 h-20" />
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-4">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1 break-words"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                {...register("email", {
                  required: "Email is required.",
                  pattern: {
                    value:
                      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    message: "Invalid email format.",
                  },
                  minLength: {
                    value: 3,
                    message: "Email must be at least 3 characters long.",
                  },
                  maxLength: {
                    value: 150,
                    message: "Email cannot exceed 150 characters.",
                  },
                })}
                className={`w-full break-words px-4 py-2 text-black border ${
                  errors.email ? "border-red-500" : "border-gray-300"
                } rounded-md focus:outline-none focus:ring-2 ${
                  errors.email ? "focus:ring-red-500" : "focus:ring-blue-500"
                }`}
                placeholder="Enter your email"
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\s/g, ""); // no spaces anywhere
                }}
              />
              {errors.email && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.email.message}
                </p>
              )}
            </div>

            <div className="mb-6">
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700 mb-1 break-words"
              >
                Password
              </label>
              <input
                type="password"
                id="password"
                {...register("password", {
                  required: "Password is required.",
                })}
                className={`w-full break-words px-4 py-2 text-black border ${
                  errors.password ? "border-red-500" : "border-gray-300"
                } rounded-md focus:outline-none focus:ring-2 ${
                  errors.password ? "focus:ring-red-500" : "focus:ring-blue-500"
                }`}
                placeholder="Enter your password"
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\s/g, ""); // no spaces anywhere
                }}
              />
              {errors.password && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.password.message}
                </p>
              )}
            </div>

            <div className="mb-4 text-right">
              <button
                type="button"
                onClick={openModal}
                className="text-sm text-black-500 hover:underline"
              >
                Forgot Password?
              </button>
            </div>

            <button
              type="submit"
              className={
                "w-full font-medium py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-700 focus:ring-offset-2  text-white bg-gray-900"
              }
            >
              Login
            </button>
          </form>
        </div>
      </div>

      {/* Forgot Password Modal */}
      <ForgotPasswordModal
        isOpen={isModalOpen}
        onClose={closeModal}
        setIsModalOpen={setIsModalOpen}
        setIsResetPasswordModalOpen={setIsResetPasswordModalOpen}
        setEmail={setEmail}
      />
      <ResetPasswordModal
        isOpen={isResetPasswordModalOpen}
        onClose={closeResetPasswordModal}
        getEmail={getEmail}
      />
    </>
  );
};

export default Login;
